import { useState } from "react";

const FORMSPREE_ENDPOINT = "https://formspree.io/f/xyknbabe";

const styles = {
  form: {
    maxWidth: 520,
    margin: "0 auto",
    padding: "2rem",
    backgroundColor: "#1B2437",
    borderRadius: 8,
    color: "#fff",
  },
  formGroup: {
    marginBottom: "1.25rem",
  },
  label: {
    display: "block",
    fontSize: "0.9rem",
    fontWeight: 600,
    marginBottom: "0.4rem",
    color: "rgba(255,255,255,0.9)",
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    fontSize: 16,
    border: "1px solid rgba(255,255,255,0.2)",
    borderRadius: 6,
    backgroundColor: "rgba(255,255,255,0.06)",
    color: "#fff",
    outline: "none",
    boxSizing: "border-box",
  },
  textarea: {
    width: "100%",
    padding: "12px 14px",
    fontSize: 16,
    border: "1px solid rgba(255,255,255,0.2)",
    borderRadius: 6,
    backgroundColor: "rgba(255,255,255,0.06)",
    color: "#fff",
    outline: "none",
    resize: "vertical",
    minHeight: 120,
    boxSizing: "border-box",
  },
  checkboxWrapper: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    marginBottom: "1.5rem",
    cursor: "pointer",
  },
  checkbox: {
    width: 18,
    height: 18,
    marginTop: 3,
    flexShrink: 0,
    accentColor: "#E87722",
    cursor: "pointer",
  },
  checkboxLabel: {
    fontSize: "0.9rem",
    color: "rgba(255,255,255,0.85)",
    lineHeight: 1.5,
  },
  privacyLink: {
    color: "#E87722",
    textDecoration: "underline",
    textUnderlineOffset: 2,
  },
  submitBtn: {
    width: "100%",
    padding: "14px 24px",
    fontSize: 16,
    fontWeight: 600,
    backgroundColor: "#E87722",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    transition: "background-color 0.2s, opacity 0.2s",
  },
  submitBtnDisabled: {
    opacity: 0.7,
    cursor: "not-allowed",
  },
  error: {
    color: "#ef4444",
    fontSize: "0.9rem",
    marginBottom: "1rem",
  },
  success: {
    textAlign: "center",
    padding: "2.5rem 1rem",
    color: "#fff",
    fontSize: "1.1rem",
    lineHeight: 1.6,
  },
};

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    privacyConsent: false,
  });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          _subject: "SHA — Contact Form",
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
        }),
      });
      if (res.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", phone: "", message: "", privacyConsent: false });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <div style={styles.form}>
        <div style={styles.success}>
          <p>Thank you for your message. We'll get back to you as soon as possible.</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <input type="hidden" name="_subject" value="SHA — Contact Form" />
      <div style={styles.formGroup}>
        <label htmlFor="contact-name" style={styles.label}>
          Full name *
        </label>
        <input
          id="contact-name"
          name="name"
          type="text"
          required
          value={formData.name}
          onChange={handleChange}
          style={styles.input}
          placeholder="Your full name"
        />
      </div>
      <div style={styles.formGroup}>
        <label htmlFor="contact-email" style={styles.label}>
          Email *
        </label>
        <input
          id="contact-email"
          name="email"
          type="email"
          required
          value={formData.email}
          onChange={handleChange}
          style={styles.input}
          placeholder="your@email.com"
        />
      </div>
      <div style={styles.formGroup}>
        <label htmlFor="contact-phone" style={styles.label}>
          Phone / WhatsApp
        </label>
        <input
          id="contact-phone"
          name="phone"
          type="tel"
          value={formData.phone}
          onChange={handleChange}
          style={styles.input}
          placeholder="+57 300 123 4567"
        />
      </div>
      <div style={styles.formGroup}>
        <label htmlFor="contact-message" style={styles.label}>
          Message *
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          value={formData.message}
          onChange={handleChange}
          style={styles.textarea}
          placeholder="How can we help you?"
        />
      </div>
      <label style={styles.checkboxWrapper}>
        <input
          type="checkbox"
          name="privacyConsent"
          required
          checked={formData.privacyConsent}
          onChange={handleChange}
          style={styles.checkbox}
        />
        <span style={styles.checkboxLabel}>
          I have read and accept the{" "}
          <a href="/docs/2026-politica-tratamiento-datos-personales.pdf" target="_blank" rel="noopener noreferrer" style={styles.privacyLink} onClick={(e) => e.stopPropagation()}>
            Privacy Policy
          </a>
        </span>
      </label>
      {status === "error" && (
        <p style={styles.error}>Something went wrong. Please try again or email us at info@secondhandarmored.com.</p>
      )}
      <button
        type="submit"
        disabled={status === "sending"}
        style={{
          ...styles.submitBtn,
          ...(status === "sending" ? styles.submitBtnDisabled : {}),
        }}
      >
        {status === "sending" ? "Sending..." : "Send message"}
      </button>
    </form>
  );
}

export default ContactForm;
